module.exports = __webpack_public_path__ + "/09205cbdbed7581b426febb894c91fb2.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/templates_icon.svg
 ** module id = 1634
 ** module chunks = 0
 **/